// qaData.js - Knowledge base for CIAP Frequently Asked Questions and AI Assistant

const qaData = [
  {
    id: 1,
    question: "What Services does CIAP Provide?",
    category: "Services",
    keywords: ["service", "services", "marine", "propulsion", "engine", "overhaul", "scope", "work", "what do you do"],
    answer: "We provide comprehensive Maintenance and Overhauling of Marine Propulsion Systems (Mechanical & Electrical, Main Engines, Auxiliary Engines, Propellers & Bow Thrusters), Pre-Docking Repairs, Ship & Boat Building, Marine Refrigeration, and Industrial Engineering solutions.",
    action: { text: "Explore Services", link: "/sectors" }
  },
  {
    id: 2,
    question: "Does CIAP offer 24/7 emergency afloat repairs?",
    category: "Emergency",
    keywords: ["emergency", "afloat", "urgent", "port stay", "24/7", "breakdown", "voyage", "rider squad"],
    answer: "Yes! Our rapid-response engineering teams and mobile rider squads deploy 24/7 across all major Sri Lankan ports (Colombo, Hambantota, Galle, Trincomalee) and offshore anchorages to carry out urgent afloat repairs while minimizing vessel downtime.",
    action: { text: "Chat on WhatsApp", link: "https://wa.me/94714820101", isExternal: true, isWhatsApp: true }
  },
  {
    id: 3,
    question: "How can I get a quote or technical assessment?",
    category: "Quote",
    keywords: ["quote", "price", "cost", "estimate", "quotation", "rate", "inquire", "request", "rfq"],
    answer: "You can easily request a quote through our 'Get a Quote' button or submit project specifications directly via our Contact page. Our technical superintendent will review your scope and provide a tailored estimate promptly.",
    action: { text: "Request a Quote", link: "/contact" }
  },
  {
    id: 4,
    question: "Where is CIAP located and which ports do you serve?",
    category: "Locations",
    keywords: ["location", "where", "office", "headquarter", "address", "port", "colombo", "galle", "hambantota", "trincomalee"],
    answer: "Our headquarters is located in Athurugiriya, Sri Lanka. We actively operate across all major commercial ports: Port of Colombo, Hambantota International Port, Port of Galle, and Port of Trincomalee, as well as international maritime regions.",
    action: { text: "View Contact Details", link: "/contact" }
  },
  {
    id: 5,
    question: "Are CIAP technicians certified for marine automation & electrical systems?",
    category: "Technical",
    keywords: ["automation", "electrical", "technician", "certified", "engineers", "plc", "scada", "power management", "pms"],
    answer: "Absolutely. Our engineering team includes certified marine electrical and automation specialists experienced in diagnosing sensors, actuators, PMS controllers, bow thrusters, switchboards, and marine navigation electronics.",
    action: { text: "Marine Engineering", link: "/sectors/marine" }
  },
  {
    id: 6,
    question: "What is CIAP's vision and quality standard?",
    category: "About",
    keywords: ["vision", "quality", "safety", "standards", "mission", "values", "about"],
    answer: "CIAP's vision is to be the most competitive and trustworthy maritime and industrial engineering partner in South Asia and beyond. We adhere to rigorous international maritime standards (IACS) and zero-compromise safety protocols.",
    action: { text: "Learn About Us", link: "/About" }
  },
  {
    id: 7,
    question: "Does CIAP provide industrial engineering outside marine?",
    category: "Industrial",
    keywords: ["industrial", "power plant", "factory", "onshore", "manufacturing", "boiler", "turbine", "hydraulics"],
    answer: "Yes, CIAP leverages its deep marine engineering expertise to provide onshore industrial services, including boiler maintenance, industrial piping, hydraulic overhauls, motor rewinding, and automation for power plants and heavy industries.",
    action: { text: "Industrial Solutions", link: "/sectors/industrial" }
  },
  {
    id: 8,
    question: "How can I contact CIAP directly?",
    category: "Contact",
    keywords: ["contact", "phone", "email", "call", "hotline", "whatsapp", "reach", "number"],
    answer: "You can reach our 24/7 technical desk via phone at +94 719645645, email at ciapinfo@theciap.com, or through our WhatsApp live support for immediate response.",
    action: { text: "Call +94 719645645", link: "tel:+94719645645", isExternal: true }
  }
];

export default qaData;